import { render, staticRenderFns } from "./SupplierGeneral.vue?vue&type=template&id=c5fb12b2&scoped=true&"
import script from "./SupplierGeneral.vue?vue&type=script&lang=js&"
export * from "./SupplierGeneral.vue?vue&type=script&lang=js&"
import style0 from "./SupplierGeneral.vue?vue&type=style&index=0&id=c5fb12b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5fb12b2",
  null
  
)

export default component.exports